import { CoachService } from '@modules/coach/coach-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

const MODE_TEST = false;
const RECORD_TEST = {
    firstName: 'Cristhian TEST',
    lastName: 'Cristhian TEST',
    birthdate: {
        day: 12,
        month: 10,
        year: 1994
    },
    phoneNumber: "+34 626223879",
    email: 'cristhian@b2fans.com',
    gender: 'male',
    type: 'coachDirector',
    country: 'ES',
};

export default {
    namespaced: true,

    state: {
        findLoading: false,
        saveLoading: false,
        record: MODE_TEST ? RECORD_TEST : null,
    },

    getters: {
        record: (state) => state.record,
        findLoading: (state) => !!state.findLoading,
        saveLoading: (state) => !!state.saveLoading,
    },

    mutations: {
        RESET(state) {
            state.findLoading = false;
            state.saveLoading = false;
            state.record = null;
        },

        FIND_STARTED(state) {
            state.record = null;
            state.findLoading = true;
        },

        FIND_SUCCESS(state, payload) {
            state.record = payload;
            state.findLoading = false;
        },

        FIND_ERROR(state) {
            state.record = null;
            state.findLoading = false;
        },

        CREATE_STARTED(state) {
            state.saveLoading = true;
        },

        CREATE_SUCCESS(state) {
            state.saveLoading = false;
        },

        CREATE_ERROR(state) {
            state.saveLoading = false;
        },

        UPDATE_STARTED(state) {
            state.saveLoading = true;
        },

        UPDATE_SUCCESS(state) {
            state.saveLoading = false;
        },

        UPDATE_ERROR(state) {
            state.saveLoading = false;
        },
    },

    actions: {
        doNew({ commit }) {
            if (!MODE_TEST) {
                commit('RESET');
            }
        },

        async doFind({ commit, rootGetters }, id) {
            try {
                commit('FIND_STARTED');

                const currentManage = rootGetters['auth/manage/currentManage'];
                const manageInput = new ManageModel(currentManage).getManageModel();
                const record = await CoachService.find(id, manageInput);

                commit('FIND_SUCCESS', record);
            } catch (error) {
                Errors.handle(error);
                commit('FIND_ERROR');
                routerAsync().push('/coach');
            }
        },

        async doCreate({ commit }, { values, manage }) {
            try {
                commit('CREATE_STARTED');

                const manageInput = new ManageModel(manage).getManageModel();
                await CoachService.create(values, manageInput);
                commit('CREATE_SUCCESS');
                Message.success(i18n('entities.coach.create.success'));
                //routerAsync().push('/coach');
                routerAsync().go(-1);
            } catch (error) {
                Errors.handle(error);
                commit('CREATE_ERROR');
            }
        },

        async doUpdate({ commit }, { id, values, manage }) {
            try {
                commit('UPDATE_STARTED');

                const manageInput = new ManageModel(manage).getManageModel();
                await CoachService.update(id, values, manageInput);

                commit('UPDATE_SUCCESS');
                Message.success(i18n('entities.coach.update.success'));
                //routerAsync().push('/coach');
                routerAsync().go(-1);
            } catch (error) {
                Errors.handle(error);
                commit('UPDATE_ERROR');
            }
        },
    },
};